import React from "react";
import './pages.css';
function PrivacyPage() {
    return (
        <div className="page">
            <div className="main-container">
                <div className="surround-margin" />
                <div className="sub-container">
                    <h1>Privacy Policy</h1>

                    <p>Effective Date: 27/01/2024</p>

                    <h2>Information We Collect</h2>

                    <p>We do not collect any personally identifiable information directly from you. The only information we collect is through the use of cookies and Google Analytics.</p>

                    <ul>
                        <li><strong>Cookies:</strong> We use cookies for two main purposes:
                            <ul>
                                <li><strong>User Preferences:</strong> We use cookies to store user preferences, such as website theme. These cookies enhance your browsing experience by remembering your chosen settings.</li>
                                <li><strong>Offline Access:</strong> We also use cookies to store character information, enabling you to access this information offline. This improves accessibility and provides a more convenient experience.</li>
                            </ul>
                            <p>You can manage your cookie preferences through your browser settings. Please note that disabling cookies may affect some website functionality, including the ability to access character information offline.</p>
                        </li>
                        <li><strong>Google Analytics:</strong> We use Google Analytics, a web analytics service provided by Google, Inc. ("Google"), to collect information about how visitors use our Website. This information is collected anonymously and includes data such as:
                            <ul>
                                <li>Pages visited</li>
                                <li>Time spent on the Website</li>
                                <li>Referring websites</li>
                                <li>General location (e.g., city, country)</li>
                                <li>Device information (e.g., browser, operating system)</li>
                            </ul>
                            <p>Google Analytics uses cookies to collect this information.</p>
                        </li>
                    </ul>

                    <h2>How We Use Information</h2>

                    <p>The information collected through cookies is used to:</p>
                    <ul>
                        <li>Remember your website preferences (e.g., theme).</li>
                        <li>Provide offline access to character information.</li>
                    </ul>
                    <p>The information collected through Google Analytics is used to:</p>
                    <ul>
                        <li>Analyse website traffic and usage patterns.</li>
                        <li>Improve the Website's content and functionality.</li>
                        <li>Understand our audience and their preferences.</li>
                    </ul>

                    <h2>Information Sharing</h2>

                    <p>We only share information with Google as described in this Privacy Policy. We do not sell, rent, or otherwise disclose any information collected through Google Analytics or cookies to any other third parties.</p>

                    <h2>Data Retention</h2>

                    <p>We retain cookies related to user preferences and offline character data until they are manually deleted by the user through their browser settings. Information collected by Google Analytics is subject to Google's data retention policies. You can find more information about Google's data retention practices in their privacy policy (linked below).</p>

                    <h2>Third-Party Services</h2>

                    <p>This Website uses Google Analytics. We encourage you to review Google's privacy policy: <a target="_blank" without rel="noreferrer" href="https://www.google.com/policies/privacy/">https://www.google.com/policies/privacy/</a></p>

                    <h2>Contact Us</h2>

                    <p>If you have any questions or concerns about this Privacy Policy, please contact us at: eminencecodex@gmail.com</p>

                    <h2>Changes to this Privacy Policy</h2>

                    <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with a revised effective date.</p>
                </div>
                <div className="surround-margin" />
            </div>
        </div >
    )
}

export default PrivacyPage;